/// <amd-module name="Search/Code/Components/RightPane" />

import * as React from "react";
import * as Container from "Search/Shared/Base/Container";
import { LegacyComponent } from "VSS/Legacy/Legacy";
import { TimeoutComponent } from "Search/Shared/Components/TimeoutComponent";
import { ActionCreator } from "Search/Code/Flux/ActionCreator";
import { StoresHub, IAggregatedState, StoreName } from "Search/Code/Flux/StoresHub"

export const RightPaneContainer = Container.create<StoreName, ActionCreator, IAggregatedState, StoresHub>(
    [
        "itemContentStore",
        "previewStore"
    ],
    ({
        searchStoreState,
        itemContentStoreState,
        previewStoreState
    }, props) => {
        const { response } = searchStoreState;
        const { actionCreator, pageContext } = props;
        const { selectedItem, activatedOnPreviousNavigation } = itemContentStoreState;
        const { activeTabKey, isFullScreen } = previewStoreState;
        const items = response ? response.results.values : [];
        const resultsCount = items.length;
        const itemIndex = items.indexOf(selectedItem);

        // We don't want to hold the thread while the TTI scenarios are being rendered in the single pass
        // That's why waiting for the next tick to start loading legacy scripts to render preview.
        return (
            selectedItem ?
                <TimeoutComponent timeout={0}>
                    <LegacyComponent
                        modules={["Search/Scenarios/Shared/Preview/Code/Components/LegacyPreviewShim"]}
                        wrappedType="search.code.legacyPreview"
                        className="flex-column flex-grow relative scroll-hidden"
                        {
                        ...{
                            pageContext,
                            item: selectedItem,
                            itemIndex,
                            resultsCount,
                            activeTabKey,
                            isFullScreen,
                            activatedOnPreviousNavigation,
                            hitCount: selectedItem.hitCount,
                            onFullScreen: actionCreator.toggleFullScreen,
                            onTabChange: actionCreator.changeActiveTab,
                            onChangeItem: actionCreator.navigateToItem,
                            onFileNameClick: actionCreator.clickPreviewFileNameLink,
                            onPreviewLoaded: actionCreator.onPreviewLoaded,
                            onDownload: actionCreator.onFileDownload
                        }
                        }
                    />
                </TimeoutComponent>
                : null
        );
    }
);
